import "./PhieuNhapKho.css";

import {
    useEffect,
    useState,
    useRef,
} from 'react';

import {
    useDispatch,
    useSelector,
} from 'react-redux';
import { PermissionAction } from 'src/actions/permission.acction';
import { NewdanhmucphieunhapAction } from 'src/actions/newdanhmucphieunhap.action';

import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    FormGroup,
    TextField,
    Typography,
    Grid,
    MenuItem,
    Select as Select1,
    InputAdornment,
    SvgIcon,
    InputLabel,
    TableCell,
} from '@material-ui/core';

import Select from 'react-select';

import numeral from 'numeral';

import { Search as SearchIcon } from 'react-feather';

import {
    CONFIRM_TYPES,
    DEFAULT_ROW_PER_PAGE,
    DEFAULT_HOMEPAGE_ROW_PER_PAGE,
    ROW_PER_PAGE_OPTIONS,
    SIM_TYPE_LIST,
    SIM_TYPE_LIST_OBJ,
    SIM_TYPE_LIST_OBJ_WITHOUT_OPERATOR,
} from 'src/utils/constants';

import moment from 'moment';
import { isGrantPermission, numberToVietnameseWords } from 'src/utils/utils';
import { NewdanhmucsanphamAction } from 'src/actions/newdanhmucsanpham.action';
import { NewdanhmuckhohangAction } from 'src/actions/newdanhmuckhohang.action';

import CreateEditDialogNewdanhmuckhohang from '../newdanhmuckhohang-detail/CreateEditDialog';
import CreateEditDialogNewdanhmucsanpham from '../newdanhmucsanpham-detail/CreateEditDialog';

import { toIntDate } from 'src/utils/common.js';

const CreateEditDialog = (props) => {
    const dispatch = useDispatch();
    const today = new Date();
    const padZero = (num) => String(num).padStart(2, "0");
    
    const { items } = useSelector(state => state.permission);
    const { selected } = useSelector(state => state.newdanhmucphieunhap);
    const { info, permissions, role } = useSelector(state => state.profile);
    const [so_hoa_don_ban_hang, setSoHoaDonBanHang] = useState("");
    const [don_vi, setDonVi] = useState("CÔNG TY TNHH NĂNG LƯỢNG XANH SONG ĐAN");
    const [bo_phan, setBoPhan] = useState("");
    const [no, setNo] = useState("");
    const [co, setCo] = useState("");
    const [ngay, setNgay] = useState(padZero(String(today.getDate())));
    const [thang, setThang] = useState(padZero(String(today.getMonth() + 1)));
    const [nam, setNam] = useState(padZero(String(today.getFullYear())));
    // const [so, setSo] = useState("{Hiển thị sau khi tạo phiếu}");
    const [so, setSo] = useState("");
    const [ho_va_ten_nguoi_giao, setHoVaTenNguoiGiao] = useState("");
    const [theo, setTheo] = useState("");
    const [theo_so, setTheoSo] = useState("");
    const [theo_so_ngay, setTheoSoNgay] = useState(padZero(String(today.getDate())));
    const [theo_so_thang, setTheoSoThang] = useState(padZero(String(today.getMonth() + 1)));
    const [theo_so_nam, setTheoSoNam] = useState(padZero(String(today.getFullYear())));
    const [theo_so_cua, setTheoSoCua] = useState("");
    const [dia_chi, setDiaChi] = useState("");
    const [tong_so_tien_viet_bang_chu, setTongSoTienVietBangChu] = useState("");
    const [so_chung_tu_goc_kem_theo, setSoChungTuGocKemTheo] = useState("");

    const [rows, setRows] = useState([
        { id: 1, name: "", code: "", unit: "", qtyDoc: "", qtyReal: "", price: "", total: "" },
    ]);

    const [sanphamList, setSanphamList] = useState([]);

    const [khohang_id, setKhohangId] = useState("-99");
    const [khohang_name, setKhohangName] = useState("");
    const [khohang_select, setKhohangSelect] = useState(undefined);
    const [khohangList, setKhohangList] = useState([]);

    const [tongSoLuongChungTu, setTongSoLuongChungTu] = useState("x");
    const [tongSoLuongThucNhap, setTongSoLuongThucNhap] = useState("x");
    const [tongDonGia, setTongDonGia] = useState("x");
    const [tongDonGiaSauChietKhau, setTongDonGiaSauChietKhau] = useState("x");
    const [tongSoLuong, setTongSoLuong] = useState("x");
    const [tongThanhTien, setTongThanhTien] = useState("x");

    const defaultSelectSanPham = 'Chọn sản phẩm...';
    const defaultSelectKhoHang = 'Chọn kho hàng...';

    const additionalOptionSanpham = { 'id': '-99', 'ma': defaultSelectSanPham, 'ten': '' };
    const additionalOptionKhohang = { 'id': '-99', 'ma': defaultSelectKhoHang, 'ten': '' };

    const [openNewdanhmuckhachhang, setOpenNewdanhmuckhachhang] = useState(false);
    const [openNewdanhmuckhohang, setOpenNewdanhmuckhohang] = useState(false);
    const [openNewdanhmucsanpham, setOpenNewdanhmucsanpham] = useState(false);

    //==========

    const handleClickOpenNewdanhmuckhachhang = () => {
        setOpenNewdanhmuckhachhang(true);
    };

    const handleCloseNewdanhmuckhachhang = () => {
        setOpenNewdanhmuckhachhang(false);
        fetchData();
    };

    //==========

    const handleClickOpenNewdanhmuckhohang = () => {
        setOpenNewdanhmuckhohang(true);
    };

    const handleCloseNewdanhmuckhohang = () => {
        setOpenNewdanhmuckhohang(false);
        fetchData();
    };

    //==========

    const handleClickOpenNewdanhmucsanpham = () => {
        setOpenNewdanhmucsanpham(true);
    };

    const handleCloseNewdanhmucsanpham = () => {
        setOpenNewdanhmucsanpham(false);
        fetchData();
    };

    //==========

    const fetchData = async() => {
        const _sanphamList = await dispatch(NewdanhmucsanphamAction.sanphamList());
        if (_sanphamList && typeof _sanphamList.data !== 'undefined' && typeof _sanphamList.data.values !== 'undefined') setSanphamList(_sanphamList.data.values);

        const _khohangList = await dispatch(NewdanhmuckhohangAction.khohangList());
        if (_khohangList && typeof _khohangList.data !== 'undefined' && typeof _khohangList.data.values !== 'undefined') setKhohangList(_khohangList.data.values);
    }

    useEffect(() => {
        if (props.open == true) {
            fetchData();

            // resetState();

            if (props.type == 'CREATE') {
                // recalculate([], false);
            }

            if (props.type == 'EDIT' && selected) {
                resetState();

                setSoHoaDonBanHang(selected.so_hoa_don_ban_hang ?? '');
                setDonVi(selected.don_vi ?? '');
                setBoPhan(selected.bo_phan ?? '');
                setNo(selected.no ?? '');
                setCo(selected.co ?? '');
                setNgay(selected.ngay ? padZero(selected.ngay) : '');
                setThang(selected.thang ? padZero(selected.thang) : '');
                setNam(selected.nam ? padZero(selected.nam) : '');
                setSo(selected.so ?? '');
                setHoVaTenNguoiGiao(selected.ho_va_ten_nguoi_giao ?? '');
                setTheo(selected.theo ?? '');
                setTheoSo(selected.theo_so ?? '');
                setTheoSoNgay(selected.theo_so_ngay ? padZero(selected.theo_so_ngay) : '');
                setTheoSoThang(selected.theo_so_thang ? padZero(selected.theo_so_thang) : '');
                setTheoSoNam(selected.theo_so_nam ? padZero(selected.theo_so_nam) : '');
                setTheoSoCua(selected.theo_so_cua ?? '');
                setTongSoTienVietBangChu(selected.tong_so_tien_viet_bang_chu ?? '');
                setSoChungTuGocKemTheo(selected.so_chung_tu_goc_kem_theo ?? '');

                //==========

                if (selected.khohang_ma && selected.khohang_ma.trim() != '') {
                    const khohangLineDefault = `<div style="font-weight: bold">${selected.khohang_ma} ${selected.khohang_ten ? ` - ${selected.khohang_ten}` : ''}</div>`;
                    
                    const htmlDefault = `
                        <div>
                            ${khohangLineDefault}
                        </div>
                    `;
                    
                    setKhohangId("__OLD_ID__");
                    setKhohangName(htmlDefault);
                    setDiaChi(selected.khohang_dia_chi);
                }

                //==========

                if (selected.newdanhmucphieunhapchitiets && selected.newdanhmucphieunhapchitiets.length > 0) {
                    let newRows = [];
                    let newdanhmucphieunhapchitiets = [...selected.newdanhmucphieunhapchitiets].sort((a, b) => a.index - b.index);
                    for (let i = 0; i < newdanhmucphieunhapchitiets.length; i++) {
                        let sanpham = newdanhmucphieunhapchitiets[i];
                        
                        const productLine = `<div style="font-weight: bold">${sanpham.sanpham_ma ? `${sanpham.sanpham_ma}` : ''}</div>`;
                        
                        const ncc = sanpham.nhacungcap_ma
                            ? `<div>(${sanpham.nhacungcap_ma} - ${sanpham.nhacungcap_ten})<div>`
                            : null;
                    
                        const html = `
                            <div>
                                ${productLine}
                                ${ncc}
                            </div>
                        `;

                        newRows[i] = {};
                        newRows[i]['id'] = i + 1;
                        newRows[i]['new_ten_san_pham'] = sanpham.sanpham_ten;
                        newRows[i]['new_so_luong'] = sanpham.so_luong;
                        newRows[i]['new_so_khung'] = sanpham.so_khung;
                        newRows[i]['new_so_may'] = sanpham.so_may;
                        newRows[i]['new_dang_kiem'] = sanpham.dang_kiem;
                        newRows[i]['new_ghi_chu'] = sanpham.ghi_chu;
                        newRows[i]['name'] = {
                            sanpham_id: "__OLD_ID__",
                            sanpham_ma: sanpham.sanpham_ma,
                            sanpham_name: html,
                            sanpham_select: {
                                id: sanpham.sanpham_id,
                                ma: sanpham.sanpham_ma,
                                ten: sanpham.sanpham_ten,
                                gia_nhap: typeof sanpham.sanpham_gia_nhap !== 'undefined' ? sanpham.sanpham_gia_nhap : null,
                                chiet_khau_1: typeof sanpham.sanpham_chiet_khau_1 !== 'undefined' ? sanpham.sanpham_chiet_khau_1 : null,
                                chiet_khau_2: typeof sanpham.sanpham_chiet_khau_2 !== 'undefined' ? sanpham.sanpham_chiet_khau_2 : null,
                                chiet_khau_3: typeof sanpham.sanpham_chiet_khau_3 !== 'undefined' ? sanpham.sanpham_chiet_khau_3 : null,
                                gia_thuc_nhap_si_1: typeof sanpham.sanpham_gia_thuc_nhap_si_1 !== 'undefined' ? sanpham.sanpham_gia_thuc_nhap_si_1 : null,
                                gia_thuc_nhap_si_2: typeof sanpham.sanpham_gia_thuc_nhap_si_2 !== 'undefined' ? sanpham.sanpham_gia_thuc_nhap_si_2 : null,
                                gia_thuc_nhap_si_3: typeof sanpham.sanpham_gia_thuc_nhap_si_3 !== 'undefined' ? sanpham.sanpham_gia_thuc_nhap_si_3 : null,
                                giaxuat1: typeof sanpham.giaxuat1 !== 'undefined' ? sanpham.giaxuat1 : null,
                                giaxuat2: typeof sanpham.giaxuat2 !== 'undefined' ? sanpham.giaxuat2 : null,
                                giaxuat3: typeof sanpham.giaxuat3 !== 'undefined' ? sanpham.giaxuat3 : null,
                                newdanhmucnhacungcap_ref: {
                                    id: "__OLD_ID__",
                                    ma: sanpham.nhacungcap_ma,
                                    ten: sanpham.nhacungcap_ten,
                                    mst: sanpham.nhacungcap_mst,
                                    dia_chi: sanpham.nhacungcap_dia_chi,
                                    sdt: sanpham.nhacungcap_sdt,
                                    email: sanpham.nhacungcap_email,
                                },
                            }
                        };

                        let keyChietKhau = undefined;

                        if (sanpham.price_key == 'gia_thuc_nhap_si_1') keyChietKhau = 'chiet_khau_1';
                        else if (sanpham.price_key == 'gia_thuc_nhap_si_2') keyChietKhau = 'chiet_khau_2';
                        else if (sanpham.price_key == 'gia_thuc_nhap_si_3') keyChietKhau = 'chiet_khau_3';

                        newRows[i]['new_gia_sau_chiet_khau'] = sanpham.price_key;
                        newRows[i]['new_don_gia'] = numeral(newRows[i]?.name?.sanpham_select?.gia_nhap || 0).format('0,0[.]0');
                        newRows[i]['new_chiet_khau'] = numeral(keyChietKhau && newRows[i]?.name?.sanpham_select?.[keyChietKhau] || 0).format('0,0[.]0') + '%';
                    }

                    setRows(newRows);
                    recalculate(newRows, false);
                } else {
                    recalculate([], false);
                }
            }
        }
    }, [props])

    function getDuplicateKhungMay(product_rows) {
        const map = {};
        const duplicates = [];
    
        product_rows.forEach(row => {
            const sk = row?.new_so_khung?.trim();
            const sm = row?.new_so_may?.trim();
            if (!sk || !sm) return;
    
            const key = `${sk}__${sm}`;
    
            if (!map[key]) {
                map[key] = 1;
            } else {
                map[key]++;
            }
        });
    
        // Chỉ lấy các key có >1 lần xuất hiện
        Object.keys(map).forEach(key => {
            if (map[key] > 1) {
                const [sk, sm] = key.split("__");
                duplicates.push({
                    so_khung: sk,
                    so_may: sm
                });
            }
        });
    
        return duplicates;
    }

    const onPressPositive = async() => {
        if (khohang_id === "-99") {
            alert('Vui lòng chọn kho hàng!');
            return;
        }

        if (!toIntDate(padZero(ngay), padZero(thang), padZero(nam))) {
            alert('Ngày nhập phiếu không hợp lệ!');
            return;
        }

        if (props.type === 'EDIT') {
            const checkSoKhungSoMay = await dispatch(NewdanhmucphieunhapAction.checkSoKhungSoMay({
                phieu_id: selected.id,
                product_rows: rows
            }));
            if (checkSoKhungSoMay) {
                if (checkSoKhungSoMay.result == 'failed') {
                    alert("Lỗi kiểm tra số khung - số máy");
                    return;
                }

                alert(`Bộ số khung - số máy này đã tồn tại ở phiếu khác:\n\n${checkSoKhungSoMay.so_khung} - ${checkSoKhungSoMay.so_may}\n\nVui lòng kiểm tra lại!`);
                return;
            }

            const checkTrungBoMaTrongPhieuHienTai = getDuplicateKhungMay(rows);
            if (checkTrungBoMaTrongPhieuHienTai && checkTrungBoMaTrongPhieuHienTai.length > 0) {
                const message = checkTrungBoMaTrongPhieuHienTai
                    .map((item, index) => `${index + 1}. SK: ${item.so_khung} - SM: ${item.so_may}`)
                    .join("\n");

                alert(
                    "Các bộ số khung – số máy sau bị trùng trong phiếu:\n\n" +
                    message +
                    "\n\nVui lòng kiểm tra lại!"
                );

                return;
            }

            dispatch(NewdanhmucphieunhapAction.update(selected.id, { 
                kho_hang: khohang_id,
                product_rows: rows,
                so_hoa_don_ban_hang,
                don_vi,
                bo_phan,
                no,
                co,
                ngay: padZero(ngay),
                thang: padZero(thang),
                nam: padZero(nam),
                so,
                ho_va_ten_nguoi_giao,
                theo,
                theo_so,
                theo_so_ngay: padZero(theo_so_ngay),
                theo_so_thang: padZero(theo_so_thang),
                theo_so_nam: padZero(theo_so_nam),
                theo_so_cua,
                tong_so_tien_viet_bang_chu,
                so_chung_tu_goc_kem_theo,
            }))

            resetState();
        } else {
            const checkSoKhungSoMay = await dispatch(NewdanhmucphieunhapAction.checkSoKhungSoMay({
                phieu_id: null,
                product_rows: rows
            }));
            if (checkSoKhungSoMay) {
                if (checkSoKhungSoMay.result == 'failed') {
                    alert("Lỗi kiểm tra số khung - số máy");
                    return;
                }

                alert(`Bộ số khung - số máy này đã tồn tại ở phiếu khác:\n\nSK: ${checkSoKhungSoMay.so_khung} - SM: ${checkSoKhungSoMay.so_may}\n\nVui lòng kiểm tra lại!`);
                return;
            }

            const checkTrungBoMaTrongPhieuHienTai = getDuplicateKhungMay(rows);
            if (checkTrungBoMaTrongPhieuHienTai && checkTrungBoMaTrongPhieuHienTai.length > 0) {
                const message = checkTrungBoMaTrongPhieuHienTai
                    .map((item, index) => `${index + 1}. SK: ${item.so_khung} - SM: ${item.so_may}`)
                    .join("\n");

                alert(
                    "Các bộ số khung – số máy sau bị trùng trong phiếu:\n\n" +
                    message +
                    "\n\nVui lòng kiểm tra lại!"
                );

                return;
            }

            dispatch(NewdanhmucphieunhapAction.create({ 
                kho_hang: khohang_id,
                product_rows: rows,
                so_hoa_don_ban_hang,
                don_vi,
                bo_phan,
                no,
                co,
                ngay: padZero(ngay),
                thang: padZero(thang),
                nam,
                so,
                ho_va_ten_nguoi_giao,
                theo,
                theo_so,
                theo_so_ngay: padZero(theo_so_ngay),
                theo_so_thang: padZero(theo_so_thang),
                theo_so_nam,
                theo_so_cua,
                tong_so_tien_viet_bang_chu,
                so_chung_tu_goc_kem_theo,
            }, props.creatingFromAway))
        }
        // resetState();
        props.handleClose();
    }

    const resetState = () => {
        setSoHoaDonBanHang("");
        setDonVi("CÔNG TY TNHH NĂNG LƯỢNG XANH SONG ĐAN");
        setBoPhan("");
        setNo("");
        setCo("");
        setNgay(padZero(String(today.getDate())));
        setThang(padZero(String(today.getMonth() + 1)));
        setNam(padZero(String(today.getFullYear())));
        // setSo("{Hiển thị sau khi tạo phiếu}");
        setSo("");
        setHoVaTenNguoiGiao("");
        setTheo("");
        setTheoSo("");
        setTheoSoNgay(padZero(String(today.getDate())));
        setTheoSoThang(padZero(String(today.getMonth() + 1)));
        setTheoSoNam(padZero(String(today.getFullYear())));
        setTheoSoCua("");
        setDiaChi("");
        setTongSoTienVietBangChu("");
        setSoChungTuGocKemTheo("");

        // setRows([
        //     { 
        //         id: 1, 
        //         name: "", 
        //         code: "", 
        //         unit: "", 
        //         qtyDoc: "", 
        //         qtyReal: "", 
        //         price: "", 
        //         total: "",
                
        //         new_ten_san_pham: "",
        //         new_so_luong: "",
        //         new_don_gia: "",
        //         new_chiet_khau: "",
        //         new_gia_sau_chiet_khau: "",
        //         new_thanh_tien: "",
        //         new_so_khung: "",
        //         new_so_may: "",
        //         new_dang_kiem: "",
        //         new_ghi_chu: "",
        //     },
        // ])

        setRows([]);

        setSanphamList([]);

        setKhohangId("-99");
        setKhohangName("");
        setKhohangSelect(undefined);
        setKhohangList([]);

        fetchData();
    }

    const inputsRef = useRef({});

    const addRow = () => {
        setRows((prev) => {
            const updatedRows = [
                ...prev,
                {
                    id: prev.length + 1,
                    name: "",
                    code: "",
                    unit: "",
                    qtyDoc: "",
                    qtyReal: "",
                    price: "",
                    total: "",

                    new_ten_san_pham: "",
                    new_so_luong: "",
                    new_don_gia: "",
                    new_chiet_khau: "",
                    new_gia_sau_chiet_khau: "",
                    new_thanh_tien: "",
                    new_so_khung: "",
                    new_so_may: "",
                    new_dang_kiem: "",
                    new_ghi_chu: "",
                },
            ];
            recalculate(updatedRows, false);
            return updatedRows;
        });
    };    

    const removeRow = (id) => {
        setRows((prev) => {
            const updatedRows = prev.filter((r) => r.id !== id);
            recalculate(updatedRows, false);
            return updatedRows;
        });
    };

    const handleKeyDown = (e, rowIndex, fieldIndex) => {
        if (e.key === "Tab") {
            const fields = [
                "name", 
                // "code", 
                // "unit", 
                // "qtyDoc", 
                // "qtyReal", 
                // "price", 
                // "total",

                "new_ten_san_pham", 
                "new_so_luong", 
                "new_don_gia", 
                "new_chiet_khau", 
                "new_gia_sau_chiet_khau", 
                "new_thanh_tien", 
                "new_so_khung", 
                "new_so_may", 
                "new_dang_kiem", 
                "new_ghi_chu", 
            ];
            const isLastRow = rowIndex === rows.length - 1;
            const isLastField = fieldIndex === fields.length - 1;

            if (isLastRow && isLastField) {
                e.preventDefault();
                addRow();
                setTimeout(() => {
                    const newRowIndex = rowIndex + 1;
                    const field = fields[0];
                    const input = inputsRef.current[`${newRowIndex}-${field}`];
                    if (input) input.focus();
                }, 50);
            }
        }
    };

    const recalculate = (_rows = [], useDefault = true) => {
        let _tongSoLuongChungTu = 0;
        let _tongSoLuongThucNhap = 0;
        let _tongDonGia = 0;
        let _tongDonGiaSauChietKhau = 0;
        let _tongSoLuong = 0;
        let _tongThanhTien = 0;

        if (useDefault && _rows.length <= 0) _rows = rows;
        if (_rows && _rows.length > 0) {
            for (let rowIndex = 0; rowIndex < _rows.length; rowIndex++) {
                let soLuongChungTu = 0;
                let soLuongThucNhap = 0;
                let priceKey = null;
                let donGia = 0;
                let donGiaSauChietKhau = 0;
                let soLuong = 0;
                let thanhTien = 0;

                if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['qtyDoc'] !== 'undefined') {
                    soLuongChungTu = Number(_rows[rowIndex]['qtyDoc']);
                }

                if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['qtyReal'] !== 'undefined') {
                    soLuongThucNhap = Number(_rows[rowIndex]['qtyReal']);
                }

                if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['new_gia_sau_chiet_khau'] !== 'undefined') {
                    priceKey = _rows[rowIndex]['new_gia_sau_chiet_khau'];
                }

                if (priceKey && typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['name'] !== 'undefined' && typeof _rows[rowIndex]['name']['sanpham_select'] !== 'undefined' && typeof _rows[rowIndex]['name']['sanpham_select'][priceKey] !== 'undefined') {
                    donGiaSauChietKhau = Number(_rows[rowIndex]['name']['sanpham_select'][priceKey]);
                }

                if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['new_don_gia'] !== 'undefined') {
                    donGia = Number(_rows[rowIndex]['new_don_gia'].toString().trim().replace(/\D/g, ''));
                }

                if (typeof _rows[rowIndex] !== 'undefined' && typeof _rows[rowIndex]['new_so_luong'] !== 'undefined') {
                    soLuong = Number(_rows[rowIndex]['new_so_luong']);
                }

                thanhTien = soLuong * donGiaSauChietKhau;

                console.log(rowIndex, soLuongChungTu, soLuongThucNhap, donGia, thanhTien);

                _tongSoLuongChungTu += soLuongChungTu;
                _tongSoLuongThucNhap += soLuongThucNhap;
                _tongDonGia += donGia;
                _tongDonGiaSauChietKhau += donGiaSauChietKhau;
                _tongSoLuong += soLuong;
                _tongThanhTien += thanhTien;

                const newRows = [..._rows];
                newRows[rowIndex]['new_thanh_tien'] = (numeral(thanhTien).format('0,0[.]0'));
                setRows(newRows);
            }
        }

        console.log(_tongSoLuongChungTu, _tongSoLuongThucNhap, _tongDonGia, _tongDonGiaSauChietKhau, _tongSoLuong, _tongThanhTien)

        setTongSoLuongChungTu(_tongSoLuongChungTu == 0 ? 'x' : numeral(_tongSoLuongChungTu).format('0,0[.]0'));
        setTongSoLuongThucNhap(_tongSoLuongThucNhap == 0 ? 'x' : numeral(_tongSoLuongThucNhap).format('0,0[.]0'));
        setTongDonGia(_tongDonGia == 0 ? 'x' : numeral(_tongDonGia).format('0,0[.]0'));
        setTongDonGiaSauChietKhau(_tongDonGiaSauChietKhau == 0 ? 'x' : numeral(_tongDonGiaSauChietKhau).format('0,0[.]0'));
        setTongSoLuong(_tongSoLuong == 0 ? 'x' : numeral(_tongSoLuong).format('0,0[.]0'));
        setTongThanhTien(_tongThanhTien == 0 ? 'x' : numeral(_tongThanhTien).format('0,0[.]0'));
        setTongSoTienVietBangChu(numberToVietnameseWords(_tongThanhTien) + ' đồng chẵn');
    }

    return (
        <Dialog className='khophieu-view' open={props.open} onClose={props.handleClose}>
            <DialogTitle>
                {props.type === 'EDIT' ? "Cập nhật bản ghi" : "Tạo bản ghi mới"}
                <Button
                    color="primary"
                    variant="contained"
                    onClick={() => { resetState(); recalculate([], false); }}
                    style={{ height: '20px', padding: 0, marginTop: '-5px', width: "150px", minWidth: '20px', marginLeft: '15px', backgroundColor: 'blue', fontWeight: 'normal' }}
                >
                    RESET
                </Button>
            </DialogTitle>
            <DialogContent style={{  }}>
                <div className="phieu-container">
                    {/* Header */}
                    <div className="phieu-header" style={{height: 0}}>
                        <div className="left"></div>
                        <div className="right">
                            <div>Nợ: <input
                                type="text"
                                value={no}
                                onChange={(e) => setNo(e.target.value)}
                            /></div>
                            <div>Có: <input
                                type="text"
                                value={co}
                                onChange={(e) => setCo(e.target.value)}
                            /></div>
                        </div>
                    </div>
                    <h2 className="phieu-title">PHIẾU NHẬP KHO</h2>
                    <div className="phieu-info">
                        <div style={{textAlign: 'center', fontStyle: 'italic'}}>
                            Ngày <input
                                style={{textAlign: 'center', fontStyle: 'italic'}}
                                className="small"
                                type="text"
                                value={ngay}
                                onChange={(e) => setNgay(e.target.value)}
                            /> 
                            tháng <input
                                style={{textAlign: 'center', fontStyle: 'italic'}}
                                className="small"
                                type="text"
                                value={thang}
                                onChange={(e) => setThang(e.target.value)}
                            /> 
                            năm <input
                                style={{textAlign: 'center', fontStyle: 'italic'}}
                                className="small"
                                type="text"
                                value={nam}
                                onChange={(e) => setNam(e.target.value)}
                            />
                        </div>
                        <div style={{textAlign: 'center'}}>Số: <input
                            style={{textAlign: 'center'}}
                            className="special"
                            // readOnly
                            placeholder="PN000001/25"
                            type="text"
                            value={so}
                            onChange={(e) => setSo(e.target.value)}
                        /></div>
                        <div style={{textAlign: 'center'}}>Số hóa đơn bán hàng: <input
                            style={{textAlign: 'center'}}
                            className="special"
                            // readOnly
                            placeholder=""
                            type="text"
                            value={so_hoa_don_ban_hang}
                            onChange={(e) => setSoHoaDonBanHang(e.target.value)}
                        /></div>
                        <div>- Nhà cung cấp: <input
                            type="text"
                            value={ho_va_ten_nguoi_giao}
                            onChange={(e) => setHoVaTenNguoiGiao(e.target.value)}
                        /></div>
                        <div style={{marginTop: 6}}>
                            - Theo <input
                                type="text"
                                value={theo}
                                onChange={(e) => setTheo(e.target.value)}
                            /> số <input
                                type="text"
                                value={theo_so}
                                onChange={(e) => setTheoSo(e.target.value)}
                            /> ngày <input
                                className="small"
                                type="text"
                                value={theo_so_ngay}
                                onChange={(e) => setTheoSoNgay(e.target.value)}
                            /> tháng <input
                                className="small"
                                type="text"
                                value={theo_so_thang}
                                onChange={(e) => setTheoSoThang(e.target.value)}
                            /> năm <input
                                className="small"
                                type="text"
                                value={theo_so_nam}
                                onChange={(e) => setTheoSoNam(e.target.value)}
                            /> của <input
                                type="text"
                                value={theo_so_cua}
                                onChange={(e) => setTheoSoCua(e.target.value)}
                            />
                        </div>
                        <div>
                            - Nhập tại kho: 
                            
                            <div style={{ display: 'inline-block', margin: '0px', border: 'none', width: '50%', zIndex: '10', marginTop: 0 }} className="full-width-select has-fast-action-btn">
                                <Button
                                    className="fast-action-btn"
                                    color="primary"
                                    variant="contained"
                                    onClick={() => handleClickOpenNewdanhmuckhohang()}
                                    style={{ 
                                        backgroundColor: 'orange',
                                    }}
                                >
                                    +
                                </Button>
                                <Select
                                    classNamePrefix="nt-select"
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({
                                            ...base,
                                            zIndex: 999999,
                                        }),
                                        control: (provided) => ({
                                            ...provided,
                                            // height: 56,
                                            // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                            border: 'none',
                                        }),
                                        option: (provided) => ({
                                            ...provided,
                                            // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                        }),
                                    }}
                                    options={[additionalOptionKhohang, ...khohangList]} // Thêm vào đầu danh sách
                                    getOptionLabel={(item) =>
                                        `${item.ma + (item.ten ? (' - ' + item.ten) : '')}`
                                    }
                                    formatOptionLabel={(item, { context }) => {
                                        const khohangLine = `${item.ma}${item.ten ? ` - ${item.ten}` : ''}`;

                                        return (
                                            <div>
                                                <div class='limit-line limit-line-1' style={{ fontWeight: "bold" }}>{khohangLine}</div>
                                            </div>
                                        );
                                    }}
                                    placeholder={
                                        khohang_name
                                            ? <span dangerouslySetInnerHTML={{ __html: khohang_name }} />
                                            : <span style={{fontWeight: 'bold'}}>{defaultSelectKhoHang}</span>
                                    }
                                    components={{
                                        DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                        IndicatorSeparator: null,
                                    }}
                                    value={khohang_id || null}
                                    onChange={(newValue) => {
                                        const khohangLine = `<div style="font-weight: bold">${newValue.ma} ${newValue.ten ? ` - ${newValue.ten}` : ''}</div>`;
                                    
                                        const html = `
                                            <div>
                                                ${khohangLine}
                                            </div>
                                        `;
                                    
                                        setKhohangId(newValue.id);
                                        setKhohangName(html);
                                        setKhohangSelect(newValue);
                                        setDiaChi(newValue.dia_chi);
                                    }}
                                    isSearchable
                                />
                            </div>

                            Địa điểm: <input
                                style={{width: 350}}
                                readOnly
                                type="text"
                                value={dia_chi}
                                onChange={(e) => setDiaChi(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* Bảng sản phẩm */}
                    <div className="table-wrapper">
                        <table className="phieu-table">
                            <thead>
                                <tr>
                                    <th>STT</th>
                                    <th width="200">Mã sản phẩm</th>
                                    <th>Tên sản phẩm</th>
                                    <th width="50">Số lượng</th>
                                    <th>Đơn giá<br></br>(VND)</th>
                                    <th>Chiết khấu</th>
                                    <th>Giá sau chiết khấu<br></br>(VND)</th>
                                    <th>Thành tiền<br></br>(VND)</th>
                                    <th>Số khung</th>
                                    <th>Số máy</th>
                                    <th>Đăng kiểm</th>
                                    <th>Ghi chú</th>
                                    <th>Xóa</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows.map((row, rowIndex) => {
                                    const fields = [
                                        "name", 
                                        // "code", 
                                        // "unit", 
                                        // "qtyDoc", 
                                        // "qtyReal", 
                                        // "price", 
                                        // "total",
                        
                                        "new_ten_san_pham", 
                                        "new_so_luong", 
                                        "new_don_gia", 
                                        "new_chiet_khau", 
                                        "new_gia_sau_chiet_khau", 
                                        "new_thanh_tien", 
                                        "new_so_khung", 
                                        "new_so_may", 
                                        "new_dang_kiem", 
                                        "new_ghi_chu", 
                                    ];
                                    return (
                                        <tr key={row.id}>
                                            <td>{rowIndex + 1}</td>
                                            {fields.map((field, fieldIndex) => (
                                                <td key={field}>
                                                    {(field === 'new_ten_san_pham' || field === 'new_don_gia' || field === 'new_chiet_khau' || field === 'new_thanh_tien') && <span style={{color: 'blue'}}>{row[field]}</span>}

                                                    {(field === 'new_so_luong' || field === 'new_so_khung' || field === 'new_so_may' || field === 'new_dang_kiem' || field === 'new_ghi_chu') && <input
                                                        type="text"
                                                        value={row[field]}
                                                        placeholder="..."
                                                        onChange={(e) => {
                                                            const newRows = [...rows];
                                                            newRows[rowIndex][field] = e.target.value;
                                                            setRows(newRows);
                                                            recalculate();
                                                        }}
                                                        ref={(el) => (inputsRef.current[`${rowIndex}-${field}`] = el)}
                                                        onKeyDown={(e) => handleKeyDown(e, rowIndex, fieldIndex)}
                                                    />}

                                                    {field === 'new_gia_sau_chiet_khau' && (
                                                        <Select1
                                                            className="select-price"
                                                            style={{
                                                                height: 56,
                                                                marginTop: 0,
                                                                marginBottom: 0,
                                                                width: "100%",
                                                                marginLeft: 0,
                                                            }}
                                                            value={
                                                                typeof rows[rowIndex][field] !== 'undefined' &&
                                                                rows[rowIndex][field] != '-99' &&
                                                                rows[rowIndex][field].trim() != ''
                                                                    ? rows[rowIndex][field]
                                                                    : '-99'
                                                            }
                                                            onChange={(e) => {
                                                                const newRows = [...rows];
                                                                let keyChietKhau = undefined;

                                                                if (e.target.value == 'gia_thuc_nhap_si_1') keyChietKhau = 'chiet_khau_1';
                                                                else if (e.target.value == 'gia_thuc_nhap_si_2') keyChietKhau = 'chiet_khau_2';
                                                                else if (e.target.value == 'gia_thuc_nhap_si_3') keyChietKhau = 'chiet_khau_3';

                                                                newRows[rowIndex][field] = e.target.value;
                                                                newRows[rowIndex]['new_don_gia'] = numeral(rows[rowIndex]?.name?.sanpham_select?.gia_nhap || 0).format('0,0[.]0');
                                                                newRows[rowIndex]['new_chiet_khau'] = numeral(keyChietKhau && rows[rowIndex]?.name?.sanpham_select?.[keyChietKhau] || 0).format('0,0[.]0') + '%';
                                                                console.log(e.target.value);
                                                                setRows(newRows);
                                                                recalculate();
                                                            }}
                                                            variant="outlined"
                                                        >
                                                            <MenuItem value="-99">Chọn giá...</MenuItem>

                                                            {rows[rowIndex]?.name?.sanpham_id
                                                                ? [
                                                                    isGrantPermission(permissions, ["newdanhmucsanpham.gianhap"]) && (
                                                                        <MenuItem key="gia_nhap" value="gia_nhap">
                                                                            {numeral(rows[rowIndex].name.sanpham_select.gia_nhap).format('0,0[.]0')}<br></br>(Giá nhập)
                                                                        </MenuItem>
                                                                    ),
                                                                    isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi1"]) && (
                                                                        <MenuItem key="gia_thuc_nhap_si_1" value="gia_thuc_nhap_si_1">
                                                                            {numeral(rows[rowIndex].name.sanpham_select.gia_thuc_nhap_si_1).format('0,0[.]0')}<br></br>({(isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi2"]) || isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi3"])) ? 'Giá NCC 1' : 'Giá thực nhập'})
                                                                        </MenuItem>
                                                                    ),
                                                                    isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi2"]) && (
                                                                        <MenuItem key="gia_thuc_nhap_si_2" value="gia_thuc_nhap_si_2">
                                                                            {numeral(rows[rowIndex].name.sanpham_select.gia_thuc_nhap_si_2).format('0,0[.]0')}<br></br>({(isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi1"]) || isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi3"])) ? 'Giá NCC 2' : 'Giá thực nhập'})
                                                                        </MenuItem>
                                                                    ),
                                                                    isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi3"]) && (
                                                                        <MenuItem key="gia_thuc_nhap_si_3" value="gia_thuc_nhap_si_3">
                                                                            {numeral(rows[rowIndex].name.sanpham_select.gia_thuc_nhap_si_3).format('0,0[.]0')}<br></br>({(isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi1"]) || isGrantPermission(permissions, ["newdanhmucsanpham.giathucnhapsi2"])) ? 'Giá NCC 3' : 'Giá thực nhập'})
                                                                        </MenuItem>
                                                                    )
                                                                ]
                                                                : null}
                                                        </Select1>
                                                    )}

                                                    {field === 'name' && <div style={{ width: '100%', zIndex: '10', marginTop: 15 }} className="full-width-select has-fast-action-btn">
                                                        <Button
                                                            className="fast-action-btn"
                                                            color="primary"
                                                            variant="contained"
                                                            onClick={() => handleClickOpenNewdanhmucsanpham()}
                                                            style={{ 
                                                                backgroundColor: 'orange',
                                                            }}
                                                        >
                                                            +
                                                        </Button>
                                                        <Select
                                                            classNamePrefix="nt-select"
                                                            menuPortalTarget={document.body}
                                                            styles={{
                                                                menuPortal: base => ({
                                                                    ...base,
                                                                    zIndex: 999999,
                                                                }),
                                                                control: (provided) => ({
                                                                    ...provided,
                                                                    // height: 56,
                                                                    // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                                    border: 'none',
                                                                }),
                                                                option: (provided) => ({
                                                                    ...provided,
                                                                    // fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                                                                }),
                                                            }}
                                                            options={[additionalOptionSanpham, ...sanphamList]} // Thêm vào đầu danh sách
                                                            getOptionLabel={(item) =>
                                                                `${item.ma + (item.ten ? (' - ' + item.ten) : '') + (typeof item.newdanhmucnhacungcap_ref !== 'undefined' ? (' (' + item.newdanhmucnhacungcap_ref.ma + ' - ' + item.newdanhmucnhacungcap_ref.ten + ')') : '')}`
                                                            }
                                                            formatOptionLabel={(item, { context }) => {
                                                                const productLine = `${item.ma}${item.ten ? ` - ${item.ten}` : ''}`;
                                                                const ncc = item.newdanhmucnhacungcap_ref
                                                                    ? `${item.newdanhmucnhacungcap_ref.ma} - ${item.newdanhmucnhacungcap_ref.ten}`
                                                                    : null;

                                                                return (
                                                                    <div>
                                                                        <div class='limit-line limit-line-1' style={{ fontWeight: "bold" }}>{productLine}</div>
                                                                        {ncc && <div class='limit-line limit-line-2'>({ncc})</div>}
                                                                    </div>
                                                                );
                                                            }}
                                                            // placeholder={(sanpham_id !== '-99' ? sanpham_id : defaultSelectSanPham) || defaultSelectSanPham}
                                                            placeholder={
                                                                typeof rows[rowIndex][field] !== 'undefined' && typeof rows[rowIndex][field]['sanpham_name'] !== 'undefined' && rows[rowIndex][field]['sanpham_name']
                                                                    ? <span dangerouslySetInnerHTML={{ __html: rows[rowIndex][field]['sanpham_name'] }} />
                                                                    : <span style={{fontWeight: 'bold'}}>{defaultSelectSanPham}</span>
                                                            }
                                                            components={{
                                                                DropdownIndicator: () => <SearchIcon size={16} color="action" />,
                                                                IndicatorSeparator: null,
                                                            }}
                                                            value={typeof rows[rowIndex][field] !== 'undefined' && typeof rows[rowIndex][field]['sanpham_id'] !== 'undefined' ? rows[rowIndex][field]['sanpham_id'] : '-99'}
                                                            // onChange={(newValue) => { setSanphamId(newValue.id); setSanphamName(newValue.ma + ' - ' + newValue.ten + (typeof newValue.newdanhmucnhacungcap_ref !== 'undefined' ? (' (' + newValue.newdanhmucnhacungcap_ref.ma + ' - ' + newValue.newdanhmucnhacungcap_ref.ten + ')') : '')); setSanphamSelect(newValue); }}
                                                            onChange={(newValue) => {
                                                                console.log(rows);

                                                                // const exists = rows.some(row => 
                                                                //     (row?.sanpham_ma ?? row?.name?.sanpham_ma) === newValue.ma
                                                                // );

                                                                // if (exists) {
                                                                //     alert(`Sản phẩm có mã "${newValue.ma}" đã tồn tại!`);
                                                                //     return;
                                                                // }

                                                                const productLine = `<div class="limit-line limit-line-1" style="font-weight: bold">${newValue.ma ? `${newValue.ma}` : ''}</div>`;
                                                                const ncc = newValue.newdanhmucnhacungcap_ref
                                                                    ? `<div class="limit-line limit-line-2">(${newValue.newdanhmucnhacungcap_ref.ma} - ${newValue.newdanhmucnhacungcap_ref.ten})<div>`
                                                                    : '';
                                                            
                                                                const html = `
                                                                    <div>
                                                                        ${productLine}
                                                                        ${ncc}
                                                                    </div>
                                                                `;
                                                            
                                                                // setSanphamId(newValue.id);
                                                                // setSanphamName(html);
                                                                // setSanphamSelect(newValue);

                                                                const newRows = [...rows];
                                                                newRows[rowIndex][field] = {
                                                                    sanpham_id: newValue.id,
                                                                    sanpham_ma: newValue.ma,
                                                                    sanpham_name: html,
                                                                    sanpham_select: newValue
                                                                };
                                                                newRows[rowIndex]['new_ten_san_pham'] = newValue.ten;
                                                                setRows(newRows);
                                                                recalculate();
                                                            }}
                                                            isSearchable
                                                        />
                                                    </div>}
                                                </td>
                                            ))}
                                            <td>
                                                <button
                                                    onClick={() => {
                                                        removeRow(row.id);
                                                    }}
                                                    className="remove-btn"
                                                >
                                                    X
                                                </button>
                                            </td>
                                        </tr>
                                    );
                                })}
                                <tr style={{fontWeight: 'bold'}}>
                                    <td colSpan="3">Cộng</td>
                                    <td>{tongSoLuong}</td>
                                    <td>{tongDonGia}</td>
                                    <td>x</td>
                                    <td>{tongDonGiaSauChietKhau}</td>
                                    <td>{tongThanhTien}</td>
                                    <td>x</td>
                                    <td>x</td>
                                    <td>x</td>
                                    <td>x</td>
                                    <td></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="btn-wrapper">
                        <button onClick={addRow} className="add-btn">+ Thêm dòng</button>
                    </div>

                    <div className="phieu-info" style={{marginTop: '15px'}}>
                        <div>- Tổng số tiền (viết bằng chữ): <input
                            style={{width: '850px', maxWidth: '100%'}}
                            readOnly
                            type="text"
                            value={tong_so_tien_viet_bang_chu}
                            onChange={(e) => setTongSoTienVietBangChu(e.target.value)}
                        /></div>
                        <div>- Số chứng từ gốc kèm theo: <input
                            style={{width: '850px', maxWidth: '100%'}}
                            type="text"
                            value={so_chung_tu_goc_kem_theo}
                            onChange={(e) => setSoChungTuGocKemTheo(e.target.value)}
                        /></div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleClose}>Huỷ</Button>
                <Button onClick={onPressPositive}>{props.type === 'EDIT' ? "Cập nhật" : "Tạo"}</Button>
            </DialogActions>
            <CreateEditDialogNewdanhmuckhohang open={openNewdanhmuckhohang} handleClose={handleCloseNewdanhmuckhohang} type={"CREATE"} creatingFromAway={true} />
            <CreateEditDialogNewdanhmucsanpham open={openNewdanhmucsanpham} handleClose={handleCloseNewdanhmucsanpham} type={"CREATE"} creatingFromAway={true} />
        </Dialog >
    );
}

export default CreateEditDialog;